const messageDecodify = (message) => {
    if(message?.message) {
        return message.message;
    }
    // eslint-disable-next-line
    else if (message?.errors) {
        return message.errors[0].msg;
    }
    
    return 'Ha ocurrido un error, Por favor intente de nuevo'
}

export {
    messageDecodify,
}